import { repository, baseURL } from '@/api/base'

export default {
  async getCatalog() {
    const { data } = await repository.get(baseURL + '/monography/findAll')
    return data
  },

  async get(id) {
    const { data } = await repository.get(baseURL + '/monography/' + id)
    return data
  },

  async create(body) {
    const { data } = await repository.post(baseURL + '/monography', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(baseURL + '/monography', body)
    return data
  },

  async remove(id) {
    return await repository.delete(baseURL + '/monography/' + id)
  }
}
